

















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ArrowButton extends Vue {
  @Prop({ default: true }) initialUp!: boolean;
  @Prop({ default: false }) blackStroke!: boolean;

  private up = this.initialUp;

  onClick() {
    this.up = !this.up;
    this.$emit('arrow-button-clicked');
  }

  get stroke() {
    if (this.blackStroke) return '#131313';
    return '#ececec';
  }
}
